import { render } from "./NotAuth.vue?vue&type=template&id=85cf78b2"
import script from "./NotAuth.vue?vue&type=script&lang=js"
export * from "./NotAuth.vue?vue&type=script&lang=js"

import "./NotAuth.vue?vue&type=style&index=0&id=85cf78b2&lang=scss"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__